import { loadablePage } from 'src/utils/loadable';

export default loadablePage(
  () =>
    import(
      /* webpackChunkName: "PayByLinkModal" */ /* webpackPrefetch: true */
      './PayByLinkModal.component'
    ),
);
